import React from 'react'

const SubTitle = ({title}) => {
  return (
    <div className=' container ' >
    <div className='sub-title'>
        <h6 >{title}</h6>
        <div></div>
      </div>
    </div >
  )
}

export default SubTitle